import type { SupervisorButton } from '../types/supervisorButtons';

// Export proposal is a text-only action everywhere it appears.
const TEXT_ONLY_BUTTON_KEYS = new Set(['export']);

const ICON_BY_BUTTON_KEY: Record<string, string> = {
  share_design: 'fa-solid fa-share-nodes',
  edit_design: 'fa-solid fa-pen-nib',
  deploy_stage: 'fa-solid fa-cloud-arrow-up',
  open_live_preview: 'fa-solid fa-desktop',
  download_code: 'fa-solid fa-download',
  create_org: 'fa-solid fa-building',
  add_member: 'fa-solid fa-user-plus',
  see_tasks: 'fa-solid fa-list-check',
  install_vscode_extension: 'fa-solid fa-arrow-up-right-from-square',
  open_loops: 'fa-solid fa-repeat',
  open_skill_store: 'fa-solid fa-store',
  keep_talking: 'fa-regular fa-message',
  build: 'fa-solid fa-wrench',
  start_build: 'fa-solid fa-wrench',
  run_agents: 'fa-solid fa-play',
  apply_change: 'fa-solid fa-play',
  run_requirements: 'fa-solid fa-play',
  run_user_flows: 'fa-solid fa-play',
  run_design: 'fa-solid fa-play',
  run_architecture: 'fa-solid fa-play',
  run_tasks: 'fa-solid fa-play',
  run_start: 'fa-solid fa-play',
  resume_quota_build: 'fa-solid fa-play',
};

const ACTION_CLASS_BY_BUTTON_KEY: Record<string, string> = {
  export: 'export-proposal',
  share_design: 'share-design',
  edit_design: 'edit-design',
  deploy_stage: 'deploy-stage',
  open_live_preview: 'open-live-preview',
  download_code: 'download-code',
  create_org: 'create-org',
  add_member: 'add-member',
  see_tasks: 'see-tasks',
  install_vscode_extension: 'install-vscode-extension',
};

/** Empty for text-only actions. */
export const iconClassForSupervisorButton = (button: SupervisorButton): string => (
  TEXT_ONLY_BUTTON_KEYS.has(button.key) ? '' : ICON_BY_BUTTON_KEY[button.key] || 'fa-solid fa-arrow-right'
);

export const actionClassForSupervisorButton = (button: SupervisorButton): string => (
  ACTION_CLASS_BY_BUTTON_KEY[button.key] || 'generic-action'
);

const LOADING_LABEL_BY_ACTION: Partial<Record<SupervisorButton['action'], string>> = {
  download_code: 'Downloading...',
  navigate: 'Opening...',
  trigger_export_proposal: 'Opening...',
  open_share_modal: 'Opening...',
  open_design_editor: 'Opening...',
  trigger_stage_deploy: 'Deploying...',
  resume_quota_build: 'Resuming...',
};

export const loadingLabelForSupervisorButton = (button: SupervisorButton): string => (
  LOADING_LABEL_BY_ACTION[button.action] || 'Working...'
);
